"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateOpportunityRfpCoverDetailDto = void 0;
const mapped_types_1 = require("@nestjs/mapped-types");
const create_rfp_cover_detail_dto_1 = require("./create-rfp-cover-detail.dto");
class UpdateOpportunityRfpCoverDetailDto extends (0, mapped_types_1.PartialType)(create_rfp_cover_detail_dto_1.CreateOpportunityRfpCoverDetailDto) {
}
exports.UpdateOpportunityRfpCoverDetailDto = UpdateOpportunityRfpCoverDetailDto;
